export default __webpack_public_path__ + "assets/images/c74283e8115f7d4049ba1483a321e114.png";